import * as React from 'react';
import { StateFilter } from '../../../../../../Machine';
import { LazyDurabilityQuestions } from '../../../questionnaires/DurabilityQuestionnaire';
import { LazyConseilDurabilityResults } from './components';
import { Suspended } from '../../../../../../Suspended';

export const ConseilDurability = () => (
  <>
    <StateFilter is=".questions">
      <Suspended>
        <LazyDurabilityQuestions />
      </Suspended>
    </StateFilter>
    <StateFilter is=".results">
      <Suspended>
        <LazyConseilDurabilityResults />
      </Suspended>
    </StateFilter>
  </>
);
